import classNames from 'classnames';
import useNavigateWithSearch from '../../../../../../hooks/useNavigateWithSearch';
import { ROUTE_GIFT_CARDS } from '../../../../config/routes';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import EarnSvg from '../../../../images/trashie-cash-v3.svg';
import './GiftCardsCard.scss';

const GiftCardsCard = ({ title, isPostRegistration }) => {
  const contextClass = isPostRegistration ? 'post-registration' : 'service';
  const navigateWithSearch = useNavigateWithSearch();

  const handleExploreGiftCards = () => {
    navigateWithSearch(ROUTE_GIFT_CARDS);
  };

  return (
    <div className="GiftCardsCard">
      <div className="GiftCardsCard__container">
        <div className={classNames('GiftCardsCard__container--title', contextClass)}>
          {title}
        </div>
        <div className={classNames('GiftCardsCard__container--message', contextClass)}>
          {isPostRegistration && (
            <Button
              type={BUTTON_TYPE.QUATERNARY}
              size={BUTTON_SIZE.LARGE}
              onClick={handleExploreGiftCards}
            >
              Explore Gift cards
            </Button>
          )}
          {!isPostRegistration && (
            <div className="GiftCardsCard__container--message-icon">
              <img src={EarnSvg} alt="coin" height={36} width={36} />
            </div>
          )}
          <span className="GiftCardsCard__container--message-text">
            Use your TrashieCash™ rewards points to unlock premium Gift cards
          </span>
        </div>
      </div>
    </div>
  );
};

export default GiftCardsCard;
